define('drops/entityFilter/entityFilter',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/eventSource',
    'drops/entityFilter/filterInstance',
    'lq/design/editors/dropExtensionsClicks'
], function ($, _, Drop, Style, util, EventSource, FilterInstance) {
    'use strict';
    
    var base = Drop;

    var EntityFilter = function (options) {
        base.call(this, $('<div>'), options);
        EventSource.call(this, [
            'FilterAdded'
        ]);

        this.$element
            .addClass('entity-filter-drop boxToBorderSize drop-text-container');
        
        this.$title = $('<span>')
            .addClass('title')
            .addClass('drop-text-content')
            .text(this.data.title)
            .css({
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 100%',
                width: '100%'
            });
            
        this.$element
            .append($('<div />')
            .css({
                cursor: 'pointer',
                display: 'flex',
                whiteSpace: 'pre-wrap',
                height: '100%',
                width: '100%'
            })
            .append(this.$title));
            
        Style.renderStyles(this);

        this.initialPosition = util.cloneData(this.data.position);

        this.clicks({
            drag: true,
            revertWhenDroppedOffTarget: true,
            getDropTargets: this.getDropTargets.bind(this),
            droppedOnTarget: this.applyFilterToTarget.bind(this)
        });
    };

    base.extend(EntityFilter);

    EntityFilter.typeName = 'EntityFilter';

    EntityFilter.currentPopup = null;

    EntityFilter.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    EntityFilter.prototype.getDropTargets = function () {
        if (!this.targetsCached) {
            var dropFactory = this.piping.dropFactory;

            this.targetsCached = _.map(this.data.targets, function (targetOptions) {
                return dropFactory.findDropByName(targetOptions.drop);
            });
        }

        return this.targetsCached;
    };

    EntityFilter.prototype.getOptionsForTarget = function(targetDrop) {
        return _.findWhere(this.data.targets, { drop: targetDrop.data.name });
    };

    // note: this method won't execute any queries
    EntityFilter.prototype.removeAppliedFilters = function () {
        _.each(this.getDropTargets(), this.removeAppliedFilter.bind(this));
    };
    
    EntityFilter.prototype.removeAppliedFilter = function (targetDrop) {
        _.each(this.getMyActiveFiltersForTarget(targetDrop), function (activeFilter) {
            activeFilter.resetFilter();
            activeFilter.remove(true);
        });
    };

    EntityFilter.prototype.applyFilterToTarget = function (targetDrop) {
        this.closeCurrentPopup();

        var activeFilterInstances = this.getActiveFiltersForTarget(targetDrop);

        var self = this;
        var isAlreadyFiltered = _.find(activeFilterInstances, function(current) {
            return current.filter === self;
        });

        if (isAlreadyFiltered) {
            this.animateBackToStart();
            return;
        }

        var targetOptions = this.getOptionsForTarget(targetDrop);

        this.removeConflictingFiltersFromTarget(targetDrop, targetOptions);
        
        this.dragToPosition(this.initialPosition);
        this.$element.hide().fadeIn({
            duration: 'slow',
            queue: false
        });

        var instance = this.createInstance(targetDrop, targetOptions, false);
        instance.applyFilterToTarget();
        this.addAsActiveFilterToTarget(instance);
    };

    EntityFilter.prototype.createInstance = function (targetDrop, targetOptions, hasInitialValue) {
        return new FilterInstance(this, targetDrop, targetOptions, hasInitialValue);
    };
    
    EntityFilter.prototype.closeCurrentPopup = function () {
        if (EntityFilter.currentPopup)
            this.hideSettingsPopup(EntityFilter.currentPopup, true);
    };
    
    EntityFilter.prototype.removeConflictingFiltersFromTarget = function (targetDrop, targetOptions) {
        if (!targetOptions.filterParameterName)
            return;

        var conflictingFilterInstances = _.filter(this.getActiveFiltersForTarget(targetDrop), function (filterInstance) {
            return filterInstance.options.filterParameterName === targetOptions.filterParameterName;
        });
        
        _.each(conflictingFilterInstances, function (filterInstance) {
            filterInstance.remove();
        });
    };
    
    EntityFilter.prototype.getActiveFiltersForTarget = function (targetDrop) {
        return targetDrop.$element.data('licquid-entity-filters') || [];
    };

    EntityFilter.prototype.getMyActiveFiltersForTarget = function (targetDrop) {
        var self = this;
        return _.filter(this.getActiveFiltersForTarget(targetDrop), function (activeFilter) {
            return activeFilter.filter === self;
        });
    };

    EntityFilter.prototype.addAsActiveFilterToTarget = function (filterInstance) {
        var activeFilters = this.getActiveFiltersForTarget(filterInstance.targetDrop);
        var newFilters = activeFilters.concat(filterInstance);
        filterInstance.targetDrop.$element.data('licquid-entity-filters', newFilters);

        filterInstance.withOnceRemoved(this.removeAsActiveFilterFromTarget.bind(this, filterInstance));

        this.triggerFilterAdded(filterInstance);
    };
    
    EntityFilter.prototype.removeAsActiveFilterFromTarget = function (filterInstance) {
        var activeFilters = this.getActiveFiltersForTarget(filterInstance.targetDrop);
        var self = this;
        var filtersWithoutSelf = _.filter(activeFilters, function(current) {
            return current.filter !== self;
        });
        filterInstance.targetDrop.$element.data('licquid-entity-filters', filtersWithoutSelf);
    };

    EntityFilter.prototype.getEventDataForTarget = function (targetOptions, eventName) {
        return targetOptions && targetOptions.eventing && targetOptions.eventing[eventName] || {};
    };

    EntityFilter.prototype.triggerEventForTargetIfEnabled = function (targetOptions, eventName) {
        var eventData = this.getEventDataForTarget(targetOptions, eventName);
        if (eventData.enabled) this.triggerEvent(eventData.raisedEventName);
    };

    return EntityFilter;
});
